import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "signup-sheet" }
const _hoisted_2 = {
  key: 0,
  class: "signup-sheet__header"
}
const _hoisted_3 = { class: "sign-up signup-sheet__content" }
const _hoisted_4 = {
  key: 0,
  class: "shortform-sign-up__group signup-sheet__group"
}
const _hoisted_5 = { class: "shortform-sign-up__group signup-sheet__group" }
const _hoisted_6 = {
  key: 1,
  class: "shortform-sign-up__group signup-sheet__group"
}
const _hoisted_7 = {
  key: 2,
  class: "text-muted font-italic"
}
const _hoisted_8 = {
  key: 0,
  class: "text-success font-weight-700"
}
const _hoisted_9 = {
  key: 1,
  class: "text-info font-weight-700"
}
const _hoisted_10 = {
  key: 2,
  class: "text-warning font-weight-700"
}
const _hoisted_11 = {
  key: 3,
  class: "text-danger font-weight-700"
}
const _hoisted_12 = {
  key: 4,
  class: "text-danger font-weight-700"
}
const _hoisted_13 = {
  key: 3,
  class: "alert alert-danger"
}
const _hoisted_14 = { class: "shortform-sign-up__group" }
const _hoisted_15 = { class: "signup-sheet__submit btns" }
const _hoisted_16 = { class: "signup-sheet__links" }

import type { SignupView } from '@/models/auth/models'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import FormError from '@/components/ui/FormError.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SignupSheet',
  props: {
    view: {},
    showNameInput: { type: Boolean },
    hideHeader: { type: Boolean, default: false },
    passwordless: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_spinner = _resolveComponent("button-spinner")!
  const _component_v_wait = _resolveComponent("v-wait")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.hideHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "signup-sheet__title-wrapper" }, [
            _createElementVNode("h2", { class: "signup-sheet__title" }, "Create Account")
          ], -1)),
          _createVNode(_component_router_link, {
            class: "signup-sheet__login",
            to: { name: 'login' }
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Login", -1)
            ]))]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", {
        class: "shortform-sign-up__form",
        role: "form",
        novalidate: "",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (__props.view.start()), ["prevent"]))
      }, [
        (__props.showNameInput)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                class: "shortform-sign-up__label signup-sheet__label",
                for: "register_username"
              }, "Full Name", -1)),
              _createVNode(InputWithContextMenu, {
                id: "register_username",
                modelValue: __props.view.model.full_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.view.model.full_name) = $event)),
                class: _normalizeClass(["shortform-sign-up__input signup-sheet__input", __props.view.validation.stateClass('username')]),
                type: "text",
                placeholder: ""
              }, null, 8, ["modelValue", "class"]),
              _createVNode(FormError, {
                errors: __props.view.validation.errors,
                field: "username"
              }, null, 8, ["errors"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            class: "shortform-sign-up__label signup-sheet__label",
            for: "register_email"
          }, "Email Address", -1)),
          _createVNode(InputWithContextMenu, {
            id: "register_email_onboarding",
            modelValue: __props.view.model.email,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.view.model.email) = $event)),
            class: _normalizeClass(["shortform-sign-up__input signup-sheet__input", __props.view.validation.stateClass('email')]),
            type: "email",
            placeholder: "",
            autofocus: ""
          }, null, 8, ["modelValue", "class"]),
          _createVNode(FormError, {
            errors: __props.view.validation.errors,
            field: "email"
          }, null, 8, ["errors"])
        ]),
        (!__props.passwordless)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                class: "shortform-sign-up__label signup-sheet__label",
                for: "register_password"
              }, "Password", -1)),
              _createVNode(InputWithContextMenu, {
                id: "register_password_onboarding",
                modelValue: __props.view.model.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.view.model.password) = $event)),
                type: "password",
                autocomplete: "new-password",
                placeholder: "",
                class: _normalizeClass(["shortform-sign-up__input signup-sheet__input", __props.view.validation.stateClass('password')])
              }, null, 8, ["modelValue", "class"]),
              _createVNode(FormError, {
                errors: __props.view.validation.errors,
                field: "password"
              }, null, 8, ["errors"])
            ]))
          : _createCommentVNode("", true),
        (!__props.passwordless && __props.view.model.password_score)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("small", null, [
                _cache[9] || (_cache[9] = _createTextVNode(" password strength: ", -1)),
                (__props.view.model.password_score === '4')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "strong"))
                  : _createCommentVNode("", true),
                (__props.view.model.password_score === '3')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "good"))
                  : _createCommentVNode("", true),
                (__props.view.model.password_score === '2')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "medium"))
                  : _createCommentVNode("", true),
                (__props.view.model.password_score === '1')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "weak"))
                  : _createCommentVNode("", true),
                (__props.view.model.password_score === '0')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "terrible"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (__props.view.validation.errors && __props.view.validation.errors._schema)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " {view.validation.errors._schema} "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_v_wait, { for: "Register" }, {
            waiting: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _cache[10] || (_cache[10] = _createTextVNode(" Creating Account ", -1)),
                _createVNode(_component_button_spinner)
              ])
            ]),
            default: _withCtx(() => [
              _cache[11] || (_cache[11] = _createElementVNode("button", {
                class: "signup-sheet__submit btns",
                type: "submit"
              }, " Create Account ", -1))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[14] || (_cache[14] = _createTextVNode(" By creating an account, you agree to the ", -1)),
          _createVNode(_component_router_link, {
            to: { name: 'site_terms' },
            class: "black",
            target: "_blank"
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Terms of Service", -1)
            ]))]),
            _: 1
          }),
          _cache[15] || (_cache[15] = _createTextVNode(" and ", -1)),
          _createVNode(_component_router_link, {
            to: { name: 'site_privacy' },
            class: "black",
            target: "_blank"
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("Privacy Policy", -1)
            ]))]),
            _: 1
          }),
          _cache[16] || (_cache[16] = _createTextVNode(". ", -1))
        ])
      ], 32)
    ])
  ]))
}
}

})